import { toast } from "react-toastify";

const toastConfig = {
  position: "bottom-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored",
};

export const showSuccessToast = (message) => {
  toast.success(message, toastConfig);
};

export const showErrorToast = (message) => {
  toast.error(message, toastConfig);
};

export const showSSHEndPoint = (sshEndPoint) => {
  toast(`Your SSH End Point is ${sshEndPoint}`, toastConfig);
};

export const showWarnToast = (message) => {
  toast.warn(message, toastConfig);
};

// export const showRobotSignallingConnectionToast = (message, re) => {
//   toast.warn(<Message />, {
//     position: "bottom-center",
//     autoClose: 5000,
//     hideProgressBar: false,
//     closeOnClick: true,
//     pauseOnHover: true,
//     draggable: true,
//     progress: undefined,
//     theme: "colored",
//   });
// };
